import React, { useState, useEffect } from 'react';
import loaderIcon from '../../assets/images/icons/loader.gif';
import pptIcon from '../../assets/images/icons/ppt.svg';
import deleteIcon from '../../assets/images/icons/trash.svg';
import googleIcon from '../../assets/images/icons/google-ads.svg';
import uploadIcon from '../../assets/images/icons/upload-cloud.svg';
import HeaderUi from '../header/Header';
import { Col, Row, Input, Space, Select, Radio, Switch } from 'antd';
import { default as ReactSelect } from 'react-select';

const CustomOption = ({ value, label }) => (
    <div className="d-flex gap-10">
        <span>{value}</span><b>{label}</b>
    </div>
);
const codeOptions = [
    { value: 'USA', label: '+1' },
    { value: 'Pakistan', label: '+92' },
    { value: 'Germany', label: '+49' },
    { value: 'Kenya', label: '+254' },
    { value: 'Nigeria', label: '+234' },
    { value: 'United arab emirates hello js', label: '+2344' }
];
// const countryOptions = [
//     { value: 'USA', label: '+1' },
//     { value: 'Pakistan', label: '+92' },
//     { value: 'Germany', label: '+49' },
//     { value: 'Kenya', label: '+254' },
//     { value: 'Nigeria', label: '+234' },
// ];
const { Option } = Select;

const options = [
    {
        value: 'skype',
        label: 'Skype',
    },
    {
        value: 'wechat',
        label: 'Wechat',
    },
    {
        value: 'telegram',
        label: 'Telegram',
    },
];
function OnboardingFormUi() {

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            padding: 10,
            display: 'flex',
            alignItems: 'center',
        }),
    };

    const formatOptionLabel = ({ value, label }) => (
        <div className="d-flex gap-10">
            <span>{value}</span><b>{label}</b>
        </div>
    );
    const [selectedOption, setSelectedOption] = useState(null);

    const handleChange = option => {
        setSelectedOption(option);
    };
    const [value, setValue] = useState(1);
    const onChange = (e) => {
        console.log('radio checked', e.target.value);
        setValue(e.target.value);
    };
    const onChangeSwitch = (checked) => {
        console.log(`switch to ${checked}`);
    };

    React.useEffect(() => {
        setTimeout(() => {
            const reactInput = document.getElementById('react-select-5-input')
            reactInput?.setAttribute("placeholder", "Search");
        }, 1500);
    })

    useEffect(() => {
        const inputs = document.querySelectorAll('.ant-select-selection-search-input');

        inputs.forEach(input => {
            const handleInput = () => {
                const parent = input.closest('.ant-select-selection-search');
                if (input.value.length > 0) {
                    parent.classList.add('searching');
                } else {
                    parent.classList.remove('searching');
                }
            };

            input.addEventListener('input', handleInput);

            // Cleanup event listener on component unmount
            return () => {
                input.removeEventListener('input', handleInput);
            };
        });
    }, []);
    return (
        <>
            <HeaderUi />

            <div className="container_box--main">
                <div className="container_box_start">
                </div>

                <div className="container_box_end">
                    <div className="container_box--intro onb mt_74">
                        <h1 className='heading'>To know your company better</h1>
                        <p className='text'>Add some more information about your company.</p>
                    </div>

                    <h2 className="sub_heading">
                        Basic Details
                    </h2>
                    <div className="container_box--form-container">
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="form_content_block--group">
                                    <label className='form_label'>Name *</label>
                                    <Input
                                        className='form_control basic'
                                        value="Harshil"
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="form_content_block--group">
                                    <label className='form_label'>Organisation Name *</label>
                                    <Input
                                        className='form_control basic'
                                        value="Xapads Media"
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="form_content_block--group">
                                    <label className='form_label'>Email Address *</label>
                                    <Input
                                        className='form_control basic'
                                        value="harshil@xapads.com"
                                        disabled
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="form_content_block--group">
                                    <label className='form_label'>Company website *</label>
                                    <Input
                                        className='form_control basic'
                                        value="www.xapads.com"
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="form_content_block--group mb_0">
                                    <label className='form_label'>IM  *</label>
                                    <Space.Compact className='form_compact basic'>
                                        <Select defaultValue="Skype" options={options} className='form_select' />
                                        <Input defaultValue="harshil" className='form_control' />
                                    </Space.Compact>
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <h2 className="sub_heading">
                        Address
                    </h2>
                    <div className="container_box--form-container">
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="form_content_block--group">
                                    <label className='form_label'>Address Line 1</label>
                                    <Input
                                        className='form_control basic'
                                        value=""
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="form_content_block--group">
                                    <label className='form_label'>City </label>
                                    <Input
                                        className='form_control basic'
                                        value=""
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="form_content_block--group">
                                    <label className='form_label'>State</label>
                                    <Input
                                        className='form_control basic'
                                        value=""
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="form_content_block--group">
                                    <label className='form_label'>Postal/ Zip Code  </label>
                                    <Input
                                        className='form_control basic'
                                        value=""
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="form_content_block--group mb_0 hide_caret_after_select_value">
                                    <label className='form_label'>Country  *</label>
                                    <Select
                                        showSearch
                                        optionFilterProp="label"
                                        className='form_select basic'
                                        // open={true}
                                        options={[
                                            {
                                                value: 'one',
                                                label: 'Loreum Ipsum',
                                            },
                                            {
                                                value: 'tow',
                                                label: 'Loreum Ipsum',
                                            },
                                            {
                                                value: 'three',
                                                label: 'Loreum Ipsum',
                                            },
                                        ]}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <h2 className="sub_heading">
                        Contact details
                    </h2>
                    <div className="container_box--form-container">
                        <Row gutter={16}>
                            <Col span={12}>
                                <div className="form_content_block--group mb_0">
                                    <label className='form_label'>Phone Number  *</label>
                                    <div className='input_group'>
                                        <ReactSelect
                                            value={selectedOption}
                                            onChange={handleChange}
                                            options={codeOptions}
                                            isSearchable={true}
                                            // menuIsOpen={true}
                                            className="form_select--w-20"
                                            classNamePrefix="form_select basic"
                                            formatOptionLabel={formatOptionLabel}
                                            styles={customStyles}
                                            placeholder=""
                                            dropdownStyle={{
                                                width: '34.4rem'
                                            }} // Set the custom width for the dropdown
                                        />
                                        <Input defaultValue="" className='form_control' />
                                    </div>
                                    {/* <Space.Compact className='form_compact basic'>
                                        <Select
                                            className='form_select'
                                            optionLabelProp="label"
                                            // open="true"
                                            defaultValue="+91"
                                            dropdownStyle={{
                                                width: '33rem'
                                            }} // Set the custom width for the dropdown
                                        >
                                            {
                                                countryOptions.map((option) => (
                                                    <Option key={option.value} value={option.value} label={option.label}>
                                                        <CustomOption value={option.value} label={option.label} />
                                                    </Option>
                                                ))
                                            }
                                        </Select>
                                        <Input defaultValue="" className='form_control' />
                                    </Space.Compact> */}
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="form_content_block--group mb_0">
                                    <label className='form_label'>Linkedin URL </label>
                                    <Input
                                        className='form_control basic'
                                        value=""
                                        placeholder='https://'
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <h2 className="sub_heading">
                        Seller details
                    </h2>
                    <div className="container_box--form-container">
                        <Row gutter={16}>
                            <Col span={24}>
                                <div className="form_content_block--group">
                                    <label className='form_label d_flex'>Seller Type *</label>
                                    <Radio.Group onChange={onChange} value={value} className="form_radio equal_space">
                                        <Radio className='radio_btn' value={1}>Publisher</Radio>
                                        <Radio className='radio_btn' value={2}>Intermediary</Radio>
                                        <Radio className='radio_btn' value={3}>Both</Radio>
                                    </Radio.Group>
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="form_content_block--group mb_0">
                                    <label className='form_label'>Seller Name *</label>
                                    <Input
                                        className='form_control basic'
                                        value=""
                                    />
                                </div>
                            </Col>
                            <Col span={12}>
                                <div className="form_content_block--group mb_0">
                                    <label className='form_label'>Seller Domain *</label>
                                    <Input
                                        className='form_control basic'
                                        value=""
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <h2 className="sub_heading">
                        Seller details
                    </h2>
                    <Row gutter={16}>
                        <Col span={12}>
                            <div className="container_box--form-container">

                                <div className="form_content_block--group mb_0 d_flex align_items_center justify_content_between">
                                    <label className='form_label form_label_switch'><img src={googleIcon} alt='USP' /> Google Ads Manager</label>
                                    <Switch defaultChecked onChange={onChangeSwitch} />


                                </div>
                            </div>
                        </Col>
                    </Row>
                    <h2 className="sub_heading">
                        Media Kit
                    </h2>
                    <Row gutter={16}>
                        <Col span={24}>
                            <div className="form_content_block--group">
                                <label for='fileUploader' className='ant_upload_drag'>
                                    <p className="upload_drag_icon">
                                        <img src={uploadIcon} alt='USP' />
                                    </p>
                                    <p className="ant_upload_text"><b className="primary">Click to upload</b> the file</p>
                                    <p className="ant_upload_hint">
                                        PPT (max. 100 MB)
                                    </p>
                                </label>
                                <input className='form_upload d-none' type="file" id="fileUploader" name="fileUploader" />

                                <div class="ant_upload_list--item">
                                    <div class="ant_upload_list--content">
                                        <img src={pptIcon} alt="USP" />
                                        <div class="ant_upload_list--info">
                                            <span class="ant_upload_list--info-name">84x84.jpg</span>
                                            <span class="ant_upload_list--info-size">0.01 MB</span>
                                        </div>
                                    </div>
                                    <button type="link" class="ant_upload_list--delete">
                                        <img src={deleteIcon} alt="USP" />
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <div className="hr_custom">

                    </div>
                    <button className='btn_primary btn'>
                        <span>submit for Approval</span>
                        <img src={loaderIcon} alt='USP' className='loader_icon' />
                    </button>
                </div>
            </div>
        </>
    )
}

export default OnboardingFormUi
